export default __webpack_public_path__ + "static/media/Group 388.d553639d.svg";